/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { shallowReactive as v, ref as r, computed as i, watch as l, unref as d, onUnmounted as f } from "vue";
const o = v(/* @__PURE__ */ new Map()), n = r(0);
let p = 0;
const m = (e, c) => {
  var t;
  (t = o.get(n.value)) == null || t.deactivate(), o.set(e, c), c.activate(), n.value = e;
}, s = (e) => {
  const c = o.get(e);
  if (o.delete(e), n.value === e) {
    c == null || c.deactivate();
    const [t, a] = [...o.entries()].pop() || [0, void 0];
    a == null || a.activate(), n.value = t;
  }
};
function k(e, c) {
  const t = ++p, a = i(() => n.value === t);
  return l(() => d(e), (u) => u ? m(t, c) : s(t), { flush: "post" }), f(() => s(t)), {
    active: a
  };
}
export {
  k as useLayerStack
};
